import React from 'react'
import { Box, CircularProgress, Typography, makeStyles } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { BoardPreview, IBoard, IBoardStyle } from '@vestaboard/installables'
import { Link as RouterLink } from 'react-router-dom'
import { MessageAppearancePreviewEntry } from './useBatchedMessageAppearancePreviews'

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 200,
    maxWidth: 280,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5)
  },
  clickable: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
    cursor: 'pointer',
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create('opacity', { duration: theme.transitions.duration.shortest }),
    '&:hover': {
      opacity: 0.88
    }
  },
  previewWrap: {
    width: '100%',
    maxWidth: 260,
    lineHeight: 0,
    '& > *': {
      maxWidth: '100%'
    }
  }
}))

export interface AnalyticsMessageAppearanceCellProps {
  messageAppearanceId: string | null
  preview: MessageAppearancePreviewEntry | undefined
}

export const AnalyticsMessageAppearanceCell: React.FC<AnalyticsMessageAppearanceCellProps> = ({
  messageAppearanceId,
  preview
}) => {
  const classes = useStyles()

  if (!messageAppearanceId) {
    return <Typography variant='body2' color='textSecondary'>—</Typography>
  }

  if (!preview) {
    return (
      <Box display='flex' alignItems='center' minHeight={48}>
        <CircularProgress size={22} />
      </Box>
    )
  }

  if (preview.status === 'error') {
    return (
      <Alert severity='warning' style={{ padding: '4px 8px', fontSize: 12 }}>
        {preview.message}
      </Alert>
    )
  }

  return (
    <div className={classes.root}>
      <RouterLink
        to={`/message-appearance/${preview.id}`}
        target='_blank'
        rel='noopener noreferrer'
        className={classes.clickable}>
        <div className={classes.previewWrap}>
          <BoardPreview
            characters={preview.characters as IBoard}
            boardStyle={preview.boardStyle as IBoardStyle}
          />
        </div>
      </RouterLink>
    </div>
  )
}
